import Reference from "@/services/reference.js";

const state = {
    diagnostics: null,
    uoms: []
};

const getters = {
    diagnostics: state => {
        return state.diagnostics;
    },
    uoms: state => {
        return Object.keys(state.uoms).map(id => ({
            value: id,
            text: state.uoms[id]
        }));
    }
};

const actions = {
    async getDiagnostics({ commit }, payload) {
        return Reference.getMasterDiagnostic(payload)
            .then(response => {
                if (response.message.code == 200) {
                    commit("setDiagnostics", response.resources);
                } else {
                    commit("unSetDiagnostics");
                }
            })
            .catch(error => error.data);
    },
    async getUOM({ commit }, payload) {
        let uoms = await Reference.getMasterUOM(payload);
        commit("setMasterUOM", uoms);
        return uoms;
    }
};

const mutations = {
    setDiagnostics(state, diagnostics) {
        state.diagnostics = diagnostics;
    },
    unSetDiagnostics(state) {
        state.diagnostics = null;
    },
    setMasterUOM(state, uoms) {
        state.uoms = uoms;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
